function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.58 5.787c-.343-.195-.746-.293-1.21-.293-.634 0-1.156.183-1.566.55-.411.366-.661.824-.75 1.372l.626.164c.075-.452.265-.812.571-1.079.306-.267.68-.4 1.12-.4.336 0 .623.071.862.215.239.144.418.327.537.55a1.429 1.429 0 0 1-.325 1.788c-.335.298-.798.488-1.388.57l.09 2.23h.504l.067-1.809c.582-.13 1.048-.387 1.4-.77.35-.384.525-.829.525-1.336 0-.35-.091-.68-.274-.992a2.088 2.088 0 0 0-.79-.76M13.37 11.988a.472.472 0 0 0-.33.129.398.398 0 0 0-.14.303c0 .123.047.226.14.308a.482.482 0 0 0 .33.123.477.477 0 0 0 .337-.123.4.4 0 0 0 .134-.308.406.406 0 0 0-.134-.303.467.467 0 0 0-.336-.129"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.79 14.973c0 .512-.454.928-1.011.928h-.123l-2.572 2.754v-2.754H3.572c-.558 0-1.012-.416-1.012-.928V3.469c0-.512.454-.928 1.012-.928h19.207c.557 0 1.011.416 1.011.928v11.504zM22.78 2.052H3.572c-.852 0-1.544.636-1.544 1.417v11.504c0 .781.692 1.417 1.544 1.417h15.98v3.586l3.353-3.59c.793-.06 1.417-.671 1.417-1.413V3.469c0-.781-.692-1.417-1.543-1.417z"
});

var SvgFaqIcon = function SvgFaqIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaqIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faq_icon.59df33b3.svg";
export { ForwardRef as ReactComponent };